import { stringify } from 'qs';
import request from '../request';
import { url } from '../service-utils';

// eslint-disable-next-line import/prefer-default-export
export function getSignWall(params) {
  return request(`${url.meetingSign}/meeting/signwall/get?${stringify(params)}`);
}

export function getSignlist(params) {
  return request(`${url.meetingSign}/meeting/signwall/signlist?${stringify(params)}`);
}
